var BufferFormatter = require('bufferformatter');
var Keyboard = require('../../lib/keyboard.es6').default;


var BufferStatusView = Backbone.View.extend({
    tagName: 'div',
    className: 'status bufferHead',
    initialize: function (options) {
        this.model.bind('remove', this.remove, this);
        this.formatter = new BufferFormatter(this.model);
    },
    render: function () {
        this.renderButtons();
        this.$el.append(this.buttons);
        
        this.label = $('<span class="bufferlabel label">');
        if (!this.model.isThread()) {
            this.label.attr('id', 'bufferlabel_' + this.model.bid());
        }
        this.renderLabel();
        
        this.title = $('<h2 class="bufferHeading">');
        this.title.append(this.label)
            .append(' ');
        this.$el.append(this.title);
        
        return this;
    },
    postrender: function () {
        if (this.model.connection.isSlackUpgradable()) {
            this.$el.append('<div class="userInfo slackLegacy">This Slack IRC gateway is closing down, but you can upgrade to a new integration. <a href="https://blog.irccloud.com/slack-integration/" target="_blank">Read the announcement and upgrade instructions</a></div>');
        }
    },
    expandTitle: function () {
        this.title.removeClass('bufferHeadingCollapsed');
        this.trigger('topChange');
    },
    collapseTitle: function () {
        this.title.addClass('bufferHeadingCollapsed');
        this.trigger('topChange');
    },
    toggleExpandTitle: function () {
        this.title.toggleClass('bufferHeadingCollapsed');
        this.trigger('topChange');
    },
    renderLabel: function () {
        this.label.html(this.formatter.render(this.model.getTitle()));
    },
    appendOptionsButton: function () {
        var menuId;
        if (this.model.isChannel()) {
            menuId = 'channelContextMenu';
        } else if (this.model.isConversation()) {
            menuId = 'conversationContextMenu';
        } else if (this.model.isServerLog()) {
            menuId = 'serverLogContextMenu';
        }
        var button = $('<button class="bufferOptions fa fa-cog">').attr({
            'title': "Options",
            'aria-label': "Options",
            'aria-expanded': false,
            'aria-controls': menuId,
            'aria-haspopup': 'true'
        });
        button.click(_.bind(function (e) {
            this.model.session.trigger('bufferOptions', button, this.model, e);
            return false;
        }, this));
        this.buttons.append(button);
    },
    renderButtons: function () {
        this.buttons = $('<p class="buttons">');
    },
    appendButton: function (className, text, image) {
        var span = $('<span>').text(text);
        if (image) {
            span.append(image);
        }
        var button = $('<button>').addClass(className).append(span);
        this.buttons.append(button);
    }
});


module.exports = BufferStatusView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/bufferstatusview.js
// module id = 6G2X
// module chunks = 1